const STORAGE_KEY = 'do-sense-recent-document-ids'
const MAX_RECENT = 5
const CHANGE_EVENT = 'do-sense-recent-documents-changed'

/**
 * Ids only. The Recent row renders from the live document library, so a cached
 * copy of the row would go stale (renames, indexing state) or outlive a delete.
 *
 * @returns {string[]}
 */
export function readRecentDocumentIds() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    if (!Array.isArray(parsed)) return []
    return parsed.filter((id) => typeof id === 'string' && id).slice(0, MAX_RECENT)
  } catch {
    return []
  }
}

/** @param {{ id?: string }[]} items documents the user just attached */
export function pushRecentDocuments(items) {
  const ids = (Array.isArray(items) ? items : [])
    .map((item) => String(item?.id ?? ''))
    .filter(Boolean)
  if (!ids.length) return readRecentDocumentIds()
  const merged = [...new Set([...ids, ...readRecentDocumentIds()])].slice(0, MAX_RECENT)
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(merged))
  window.dispatchEvent(new Event(CHANGE_EVENT))
  return merged
}

export function subscribeRecentDocumentIds(listener) {
  const handler = () => listener(readRecentDocumentIds())
  window.addEventListener(CHANGE_EVENT, handler)
  return () => window.removeEventListener(CHANGE_EVENT, handler)
}

export { CHANGE_EVENT, MAX_RECENT }
